import "./AddUpdateAppointmentModal.css";
import { Fragment, useEffect, useState } from "react";

// MUI Start
import Modal from "@mui/material/Modal";
import Autocomplete from "@mui/material/Autocomplete";
import { Avatar, Card, MenuItem, TextField, Typography } from "@mui/material";
// MUI End

// Controllers Start
import GetTotalLeads from "../../../controllers/leads/GetTotalLeads";
import GetSingleLeadData from "../../../controllers/leads/GetSingleLeadData";
import GetLeadDealController from "../../../controllers/Enquiries/GetLeadDealController";
import GetSingleDeal from "../../../controllers/Enquiries/GetSingleDeal";
import GetAdmin from "../../../controllers/admin/GetAdmin";
import GetTotalAgents from "../../../controllers/agents/GetTotalAgents";
import GetSingleAgentData from "../../../controllers/agents/GetSingleAgentData";
import GetSingleAppointmentData from "../../../controllers/appointments/GetSingleAppointmentData";
import { ToastSuccessMessages } from "../../../controllers/auth/AuthErrorMessages";
import UpdateAppointmentStatus from "../../../controllers/appointments/UpdateAppointmentStatus";
import AddAppointment from "../../../controllers/appointments/AddAppointment";
import UpdateSingleAppointment from "../../../controllers/appointments/UpdateSingleAppointment";
// Controllers End

import { getAuth } from "firebase/auth";
import moment from "moment";
import CalenderSVG from "./icons/calendar.svg";
import Calendar from "react-calendar";
import { stringAvatar } from "../../../helpers/stringAvatar";

const AddUpdateAppointmentModal = (props) => {
  let {
    AppointmentId,
    setAppointmentId,
    handleRefresh,
    OpenAddUpdateModal,
    setOpenAddUpdateModal,
    dealId,
    selectedAppointmentClient,
    dealData,
  } = props;
  // const [Refresh, setRefresh] = useState(true);
  const [StartWeekViewToggler, setStartWeekViewToggler] = useState(false);
  const [ClientID, setClientID] = useState("");
  const [ClientObject, setClientObject] = useState({});
  const [DealObject, setDealObject] = useState({});
  const [UserObject, setUserObject] = useState({});
  const [DealID, setDealID] = useState("");
  const [AgentID, setAgentID] = useState("");
  const [MarkAsDone, setMarkAsDone] = useState(false);
  const [ClientName, setClientName] = useState("");
  // const [OpenAddUpdateModal, setOpenAddUpdateModal] = useState(false);
  const [SingleAppointmentData, setSingleAppointmentData] = useState({});
  // const [AppointmentId, setAppointmentId] = useState("");

  const [ClientDetails, setClientDetails] = useState({});
  const [DealDetails, setDealDetails] = useState({});
  const [AgentDetails, setAgentDetails] = useState({});

  const [Type, setType] = useState("meeting");
  const [Title, setTitle] = useState("");
  const [LocalStartDate, setLocalStartDate] = useState(new Date());
  const [StartDate, setStartDate] = useState(new Date());
  const [EndDate, setEndDate] = useState(new Date());
  const [StartTime, setStartTime] = useState("12:00 pm");
  const [EndTime, setEndTime] = useState("12:30 pm");
  const [Clients, setClients] = useState([]);
  const [Deals, setDeals] = useState([]);
  const [Comments, setComments] = useState("");
  const [Agents, setAgents] = useState([]);
  const [IsCustomTitle, setIsCustomTitle] = useState(false);
  const [ModalLoader, setModalLoader] = useState(false);

  //  const [Appointments, setAppointments] = useState([]);
  const [StartTimeArray, setStartTimeArray] = useState([
    "12:00 am",
    "12:30 am",
    "1:00 am",
    "1:30 am",
    "2:00 am",
    "2:30 am",
    "3:00 am",
    "3:30 am",
    "4:00 am",
    "4:30 am",
    "5:00 am",
    "5:30 am",
    "6:00 am",
    "6:30 am",
    "7:30 am",
    "8:00 am",
    "8:30 am",
    "9:00 am",
    "9:30 am",
    "10:00 am",
    "10:30 am",
    "11:00 am",
    "11:30 am",
    "12:00 pm",
    "12:30 pm",
    "1:00 pm",
    "1:30 pm",
    "2:00 pm",
    "2:30 pm",
    "3:00 pm",
    "3:30 pm",
    "4:00 pm",
    "4:30 pm",
    "5:00 pm",
    "5:30 pm",
    "6:00 pm",
    "6:30 pm",
    "7:00 pm",
    "7:30 pm",
    "8:00 pm",
    "8:30 pm",
    "9:00 pm",
    "9:30 pm",
    "10:00 pm",
    "10:30 pm",
    "11:00 pm",
    "11:30 pm",
  ]);
  const [EndTimeArray, setEndTimeArray] = useState([
    "12:00 am",
    "12:30 am",
    "1:00 am",
    "1:30 am",
    "2:00 am",
    "2:30 am",
    "3:00 am",
    "3:30 am",
    "4:00 am",
    "4:30 am",
    "5:00 am",
    "5:30 am",
    "6:00 am",
    "6:30 am",
    "7:30 am",
    "8:00 am",
    "8:30 am",
    "9:00 am",
    "9:30 am",
    "10:00 am",
    "10:30 am",
    "11:00 am",
    "11:30 am",
    "12:00 pm",
    "12:30 pm",
    "1:00 pm",
    "1:30 pm",
    "2:00 pm",
    "2:30 pm",
    "3:00 pm",
    "3:30 pm",
    "4:00 pm",
    "4:30 pm",
    "5:00 pm",
    "5:30 pm",
    "6:00 pm",
    "6:30 pm",
    "7:00 pm",
    "7:30 pm",
    "8:00 pm",
    "8:30 pm",
    "9:00 pm",
    "9:30 pm",
    "10:00 pm",
    "10:30 pm",
    "11:00 pm",
    "11:30 pm",
  ]);

  const [IsBtnDisable, setBtnDisable] = useState(false);
  const [TitleError, setTitleError] = useState(false);
  const [LocalStartDateError, setLocalStartDateError] = useState(false);
  const [StartTimeError, setStartTimeError] = useState(false);
  const [EndTimeError, setEndTimeError] = useState(false);
  const [ClientError, setClientError] = useState(false);
  const [DealsError, setDealsError] = useState(false);
  const [UserError, setUserError] = useState(false);
  const [IsCheckError, setIsCheckError] = useState(false);

  const [IsCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    let isMounted = true; // note mutable flag

    if (isMounted) {
      if (IsCustomTitle === false) {
        const localTitle =
          Type === "meeting"
            ? `Meeting ${ClientName && "With " + ClientName}`
            : Type === "call"
            ? `Call ${ClientName && "With " + ClientName}`
            : Type === "message"
            ? `Chat ${ClientName && "With " + ClientName}`
            : Type === "email"
            ? `Email ${ClientName && "To " + ClientName}`
            : Type === "task"
            ? `Task Assign ${ClientName && "To " + ClientName}`
            : "";

        setTitle(localTitle);
      }
    }

    return () => {
      isMounted = false;
    }; // cleanup toggles value, if unmounted
  }, [ClientName, IsCustomTitle, Type]);

  const HandleOpenAddUpdateModal = async (id) => {
    if (id !== "") {
      setModalLoader(true);
      const AppointmentData = await GetSingleAppointmentData(id);
      setSingleAppointmentData(AppointmentData);

      setType(AppointmentData.type);
      setTitle(AppointmentData.title);
      setStartDate(AppointmentData.startDate);
      setStartTime(AppointmentData.startTime);
      setLocalStartDate(AppointmentData.startDate.toDate());
      setEndTime(AppointmentData.endTime);
      setComments(AppointmentData.comments);

      const clientDetails = await GetSingleLeadData(AppointmentData.client);
      setClientID(clientDetails?.id);
      setClientDetails(clientDetails);

      const dealDetails = await GetSingleDeal(AppointmentData.deal);
      setDealID(dealDetails?.id);
      setDealDetails(dealDetails);

      const { uid } = getAuth().currentUser;
      if (AppointmentData.user === uid) {
        const adminDetails = await GetAdmin();
        setAgentID(adminDetails?.id);
        setUserObject(adminDetails);
        setAgentDetails(adminDetails);
      } else {
        const agentDetails = await GetSingleAgentData(AppointmentData.user);
        setAgentID(agentDetails?.id);
        setUserObject(agentDetails);
        setAgentDetails(agentDetails);
      }

      setModalLoader(false);
    } else {
    }
  };

  useEffect(() => {
    if (AppointmentId !== "" && SingleAppointmentData.isDone === true) {
      setIsCompleted(true);
    } else {
      setIsCompleted(false);
    }
  }, [SingleAppointmentData.isDone, AppointmentId]);

  useEffect(() => {
    HandleOpenAddUpdateModal(AppointmentId);
  }, [AppointmentId]);

  // Clients useEffect Start
  useEffect(() => {
    async function fetchData() {
      let isMounted = true; // note mutable flag

      if (isMounted) {
        const leadsData = await GetTotalLeads();
        setClients(leadsData);
      }

      return () => {
        isMounted = false;
      }; // cleanup toggles value, if unmounted
    }
    fetchData();
  }, []);
  // Clients useEffect End

  // Client Deals useEffect Start
  useEffect(() => {
    async function fetchData() {
      let isMounted = true; // note mutable flag

      if (isMounted) {
        const dealsData = await GetLeadDealController(ClientID);
        setDeals(dealsData);
      }

      return () => {
        isMounted = false;
      }; // cleanup toggles value, if unmounted
    }
    fetchData();
  }, [ClientID]);
  // Client Deals useEffect End

  // Agents useEffect Start
  useEffect(() => {
    async function fetchData() {
      let isMounted = true; // note mutable flag

      if (isMounted) {
        let agentsData = await GetTotalAgents();

        let adminData = await GetAdmin();
        adminData = { ...adminData, id: adminData.uid };

        agentsData.unshift(adminData);

        setAgentID(agentsData[0].id);
        setUserObject(agentsData[0]);
        setAgents(agentsData);
      }

      return () => {
        isMounted = false;
      }; // cleanup toggles value, if unmounted
    }
    fetchData();
  }, []);
  // Agents useEffect End

  useEffect(() => {
    // Tell moment how to parse the input string
    var dateTimeStart = moment(
      LocalStartDate.toLocaleDateString() + StartTime,
      "DD/MM/YYYYLT"
    ).toDate();

    var dateTimeEnd = moment(
      LocalStartDate.toLocaleDateString() + EndTime,
      "DD/MM/YYYYLT"
    ).toDate();

    setStartDate(dateTimeStart);
    setEndDate(dateTimeEnd);
  }, [LocalStartDate, StartTime, EndTime]);

  const HandleMarkAsDone = async () => {
    // setMarkAsDone(true);
    await UpdateAppointmentStatus(AppointmentId);
    handleRefresh();
    setIsCompleted(true);
    setOpenAddUpdateModal(false);
  };

  const ErrorFunc = () => {
    let flag = 0;
    if (Title === "" || Title === null || Title === undefined) {
      setTitleError(true);
      flag++;
    } else {
      setTitleError(false);
    }
    if (
      LocalStartDate === "" ||
      LocalStartDate === null ||
      LocalStartDate === undefined
    ) {
      setLocalStartDateError(true);
      flag++;
    } else {
      setLocalStartDateError(false);
    }
    if (StartTime === "" || StartTime === null || StartTime === undefined) {
      setStartTimeError(true);
      flag++;
    } else {
      setStartTimeError(false);
    }
    if (EndTime === "" || EndTime === null || EndTime === undefined) {
      setEndTimeError(true);
      flag++;
    } else {
      setEndTimeError(false);
    }
    if (ClientID === "" || ClientID === null || ClientID === undefined) {
      setClientError(true);
      flag++;
    } else {
      setClientError(false);
    }
    if (
      Deals?.length !== 0 &&
      (DealID === "" || DealID === null || DealID === undefined)
    ) {
      setDealsError(true);
      flag++;
    } else {
      setDealsError(false);
    }
    if (AgentID === "" || AgentID === null || AgentID === undefined) {
      setUserError(true);
      flag++;
    } else {
      setUserError(false);
    }
    return flag;
  };

  useEffect(() => {
    if (IsCheckError) ErrorFunc();
  }, [IsCheckError]);

  const HandleCloseAddUpdateModal = () => {
    setOpenAddUpdateModal(false);
    setTitleError(false);
    setLocalStartDateError(false);
    setStartTimeError(false);
    setEndTimeError(false);
    setClientError(false);
    setDealsError(false);
    setUserError(false);
    setBtnDisable(false);

    setAppointmentId("");
    setType("meeting");
    setTitle("Meeting");
    setStartDate(new Date());
    setStartTime("12:00 pm");
    setEndTime("12:30 pm");
    setComments("");
    setClientID("");
    setClientName("");
    setDealID("");
  };

  const HandleSubmit = async () => {
    setIsCheckError(true);
    setBtnDisable(true);
    let flag = 0;
    flag = ErrorFunc();

    if (AppointmentId) {
      if (flag === 0) {
        const AppointmentObject = {
          type: Type,
          title: Title,
          startDate: StartDate,
          endDate: EndDate,
          startTime: StartTime,
          endTime: EndTime,
          client: ClientID,
          clientObject: ClientObject || {},
          deal: DealID || "",
          dealObject: DealObject || {},
          comments: Comments,
          user: AgentID,
          userObject: UserObject || {},
          isDone: SingleAppointmentData.isDone,
        };
        const resp = await UpdateSingleAppointment(
          AppointmentObject,
          AppointmentId
        );
        if (resp) {
          HandleCloseAddUpdateModal();
          handleRefresh();
        }
        // ToastSuccessMessages("appointment/updation-successful");
      } else {
        // AuthErrorMessages("appointment/creation-error");
        setBtnDisable(false);
      }
    } else {
      if (flag === 0) {
        const AppointmentObject = {
          type: Type,
          title: Title,
          startDate: StartDate,
          endDate: EndDate,
          startTime: StartTime,
          endTime: EndTime,
          client: ClientID || "",
          clientObject: ClientObject || {},
          deal: DealID || "",
          dealObject: DealObject || {},
          comments: Comments,
          user: AgentID || "",
          userObject: UserObject || {},
          isDone: MarkAsDone,
        };
        const resp = await AddAppointment(AppointmentObject);

        if (resp) {
          HandleCloseAddUpdateModal();
          handleRefresh();
        }
        // ToastSuccessMessages("appointment/creation-successful");
      } else {
        // AuthErrorMessages("appointment/creation-error");
        setBtnDisable(false);
      }
    }
  };

  return (
    <Fragment>
      <Modal
        open={OpenAddUpdateModal}
        onClose={HandleCloseAddUpdateModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="add-appointment-modal"
      >
        {ModalLoader ? (
          <div className="interstitial-loader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        ) : (
          <div className="modal-dialog modal-lg">
            <div className="add-appointment-modal-content modal-content">
              <div className="modal-header add-appointment-modal-header">
                <h3 className="custom-heading">
                  {AppointmentId !== ""
                    ? "Update Appointment"
                    : "Add Appointment"}
                </h3>
                <svg
                  className="add-appointment-modal-close-button"
                  onClick={HandleCloseAddUpdateModal}
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
                </svg>
              </div>
              <form
                className="modal-body"
                onSubmit={(e) => {
                  e.preventDefault();
                  HandleSubmit();
                }}
              >
                <div className="form-row add-appointment-type-container">
                  <div className="form-group col-12">
                    {/* <div className="label">Type</div> */}
                    <div className="icon-container">
                      <div
                        className={`${
                          Type === "meeting"
                            ? "single-active-icon"
                            : "single-icon"
                        }`}
                        onClick={() => {
                          setType("meeting");
                        }}
                      >
                        {Type === "meeting" ? (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="#4C3CA6" />
                            <path
                              d="M37.0969 24.8665V25.9432C37.0969 30.2496 36.0203 31.3141 31.7259 31.3141H18.2743C13.9799 31.3141 12.9033 30.2375 12.9033 25.9432V18.2738C12.9033 13.9794 13.9799 12.9028 18.2743 12.9028H20.1614M25.0001 31.3141V37.0964M12.9033 26.2093H37.0969M19.5565 37.0964H30.4436"
                              stroke="white"
                              strokeWidth="1.1"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M32.0874 21.8192H26.3293C24.66 21.8192 24.1035 20.7063 24.1035 19.5934V15.3354C24.1035 14.0047 25.1922 12.916 26.5229 12.916H32.0874C33.3213 12.916 34.3132 13.908 34.3132 15.1418V19.5934C34.3132 20.8273 33.3213 21.8192 32.0874 21.8192ZM35.7769 20.0652L34.3132 19.037V15.6983L35.7769 14.67C36.5027 14.1741 37.0954 14.4765 37.0954 15.3596V19.3878C37.0954 20.2709 36.5027 20.5733 35.7769 20.0652Z"
                              stroke="white"
                              strokeWidth="1.1"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="25"
                              cy="25"
                              r="24.5"
                              fill="white"
                              stroke="#C5C5C5"
                            />
                            <path
                              d="M37.0969 24.8665V25.9432C37.0969 30.2496 36.0203 31.3141 31.7259 31.3141H18.2743C13.9799 31.3141 12.9033 30.2375 12.9033 25.9432V18.2738C12.9033 13.9794 13.9799 12.9028 18.2743 12.9028H20.1614M25.0001 31.3141V37.0964ZM12.9033 26.2093H37.0969ZM19.5565 37.0964H30.4436Z"
                              fill="white"
                            />
                            <path
                              d="M37.0969 24.8665V25.9432C37.0969 30.2496 36.0203 31.3141 31.7259 31.3141H18.2743C13.9799 31.3141 12.9033 30.2375 12.9033 25.9432V18.2738C12.9033 13.9794 13.9799 12.9028 18.2743 12.9028H20.1614M25.0001 31.3141V37.0964M12.9033 26.2093H37.0969M19.5565 37.0964H30.4436"
                              stroke="#808080"
                              strokeWidth="1.1"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M32.0874 21.8192H26.3293C24.66 21.8192 24.1035 20.7063 24.1035 19.5934V15.3354C24.1035 14.0047 25.1922 12.916 26.5229 12.916H32.0874C33.3213 12.916 34.3132 13.908 34.3132 15.1418V19.5934C34.3132 20.8273 33.3213 21.8192 32.0874 21.8192ZM35.7769 20.0652L34.3132 19.037V15.6983L35.7769 14.67C36.5027 14.1741 37.0954 14.4765 37.0954 15.3596V19.3878C37.0954 20.2709 36.5027 20.5733 35.7769 20.0652Z"
                              fill="white"
                              stroke="#808080"
                              strokeWidth="1.1"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>

                      <div
                        className={`${
                          Type === "call" ? "single-active-icon" : "single-icon"
                        }`}
                        onClick={() => {
                          setType("call");
                        }}
                      >
                        {Type === "call" ? (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="#4C3CA6" />
                            <path
                              d="M36.7913 33.7543C36.7913 34.214 36.6892 34.6864 36.4721 35.1461C36.255 35.6058 35.9741 36.0399 35.6038 36.4485C34.9781 37.138 34.2886 37.636 33.5097 37.9553C32.7436 38.2745 31.9136 38.4405 31.0198 38.4405C29.7174 38.4405 28.3256 38.134 26.8572 37.5083C25.3888 36.8827 23.9204 36.0399 22.4647 34.9801C20.9811 33.8949 19.5811 32.6998 18.2765 31.4048C16.9853 30.105 15.7944 28.7092 14.714 27.2294C13.667 25.7738 12.8243 24.3182 12.2113 22.8753C11.5984 21.4196 11.292 20.0278 11.292 18.6999C11.292 17.8316 11.4452 17.0016 11.7517 16.2355C12.0581 15.4566 12.5433 14.7415 13.2201 14.1031C14.0373 13.2987 14.9311 12.9028 15.876 12.9028C16.2335 12.9028 16.5911 12.9794 16.9103 13.1327C17.2423 13.2859 17.5359 13.5157 17.7658 13.8477L20.7281 18.0231C20.958 18.3423 21.124 18.636 21.2389 18.9169C21.3538 19.1851 21.4177 19.4532 21.4177 19.6958C21.4177 20.0023 21.3283 20.3087 21.1495 20.6024C20.9835 20.8961 20.7409 21.2026 20.4345 21.509L19.464 22.5178C19.3236 22.6582 19.2597 22.8242 19.2597 23.0285C19.2597 23.1307 19.2725 23.22 19.298 23.3222C19.3363 23.4243 19.3747 23.5009 19.4002 23.5776C19.63 23.9989 20.0259 24.548 20.5877 25.212C21.1623 25.876 21.7752 26.5527 22.4392 27.2294C23.1287 27.9062 23.7927 28.5319 24.4694 29.1065C25.1334 29.6683 25.6824 30.0514 26.1166 30.2812C26.1804 30.3067 26.257 30.345 26.3464 30.3833C26.4486 30.4216 26.5507 30.4344 26.6656 30.4344C26.8827 30.4344 27.0487 30.3578 27.1892 30.2173L28.1596 29.2597C28.4788 28.9405 28.7853 28.6979 29.079 28.5446C29.3726 28.3659 29.6663 28.2765 29.9855 28.2765C30.2281 28.2765 30.4835 28.3276 30.7644 28.4425C31.0454 28.5574 31.339 28.7234 31.6583 28.9405L35.8847 31.9411C36.2167 32.171 36.4466 32.4391 36.587 32.7583C36.7147 33.0776 36.7913 33.3968 36.7913 33.7543V33.7543Z"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                            />
                            <path
                              d="M32.3607 21.841C32.3607 21.0749 31.7606 19.9001 30.8667 18.9425C30.0495 18.0614 28.9642 17.3719 27.8916 17.3719M36.8298 21.841C36.8298 16.8995 32.8331 12.9028 27.8916 12.9028"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="25"
                              cy="25"
                              r="24.5"
                              fill="white"
                              stroke="#C5C5C5"
                            />
                            <path
                              d="M36.7913 33.7543C36.7913 34.214 36.6892 34.6864 36.4721 35.1461C36.255 35.6058 35.9741 36.0399 35.6038 36.4485C34.9781 37.138 34.2886 37.636 33.5097 37.9553C32.7436 38.2745 31.9136 38.4405 31.0198 38.4405C29.7174 38.4405 28.3256 38.134 26.8572 37.5083C25.3888 36.8827 23.9204 36.0399 22.4647 34.9801C20.9811 33.8949 19.5811 32.6998 18.2765 31.4048C16.9853 30.105 15.7944 28.7092 14.714 27.2294C13.667 25.7738 12.8243 24.3182 12.2113 22.8753C11.5984 21.4196 11.292 20.0278 11.292 18.6999C11.292 17.8316 11.4452 17.0016 11.7517 16.2355C12.0581 15.4566 12.5433 14.7415 13.2201 14.1031C14.0373 13.2987 14.9311 12.9028 15.876 12.9028C16.2335 12.9028 16.5911 12.9794 16.9103 13.1327C17.2423 13.2859 17.5359 13.5157 17.7658 13.8477L20.7281 18.0231C20.958 18.3423 21.124 18.636 21.2389 18.9169C21.3538 19.1851 21.4177 19.4532 21.4177 19.6958C21.4177 20.0023 21.3283 20.3087 21.1495 20.6024C20.9835 20.8961 20.7409 21.2026 20.4345 21.509L19.464 22.5178C19.3236 22.6582 19.2597 22.8242 19.2597 23.0285C19.2597 23.1307 19.2725 23.22 19.298 23.3222C19.3363 23.4243 19.3747 23.5009 19.4002 23.5776C19.63 23.9989 20.0259 24.548 20.5877 25.212C21.1623 25.876 21.7752 26.5527 22.4392 27.2294C23.1287 27.9062 23.7927 28.5319 24.4694 29.1065C25.1334 29.6683 25.6824 30.0514 26.1166 30.2812C26.1804 30.3067 26.257 30.345 26.3464 30.3833C26.4486 30.4216 26.5507 30.4344 26.6656 30.4344C26.8827 30.4344 27.0487 30.3578 27.1892 30.2173L28.1596 29.2597C28.4788 28.9405 28.7853 28.6979 29.079 28.5446C29.3726 28.3659 29.6663 28.2765 29.9855 28.2765C30.2281 28.2765 30.4835 28.3276 30.7644 28.4425C31.0454 28.5574 31.339 28.7234 31.6583 28.9405L35.8847 31.9411C36.2167 32.171 36.4466 32.4391 36.587 32.7583C36.7147 33.0776 36.7913 33.3968 36.7913 33.7543V33.7543Z"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                            />
                            <path
                              d="M32.3607 21.841C32.3607 21.0749 31.7606 19.9001 30.8667 18.9425C30.0495 18.0614 28.9642 17.3719 27.8916 17.3719M36.8298 21.841C36.8298 16.8995 32.8331 12.9028 27.8916 12.9028"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>

                      <div
                        className={`${
                          Type === "message"
                            ? "single-active-icon"
                            : "single-icon"
                        }`}
                        onClick={() => {
                          setType("message");
                        }}
                      >
                        {Type === "message" ? (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="#4C3CA6" />
                            <path
                              d="M35.4973 25.0039V27.2889C35.4973 31.5227 33.0779 33.3373 29.4489 33.3373H17.3521C13.7231 33.3373 11.3037 31.5227 11.3037 27.2889V20.0308C11.3037 15.7969 13.7231 13.9824 17.3521 13.9824H20.9811C20.8064 14.4932 20.7123 15.0577 20.7123 15.6625V20.9045C20.7123 22.2082 21.1424 23.3104 21.9085 24.0765C22.6747 24.8426 23.7768 25.2727 25.0806 25.2727V27.141C25.0806 27.8265 25.8602 28.2432 26.4381 27.8668L30.3225 25.2727H33.8172C34.422 25.2727 34.9865 25.1787 35.4973 25.0039V25.0039Z"
                              fill="#4C3CA6"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M38.192 15.6544V20.8963C38.192 22.899 37.1705 24.4044 35.5038 24.9958C34.9931 25.1705 34.4286 25.2646 33.8237 25.2646H30.3291L26.4447 27.8587C25.8667 28.2351 25.0872 27.8184 25.0872 27.1329V25.2646C23.7834 25.2646 22.6813 24.8345 21.9151 24.0684C21.149 23.3023 20.7189 22.2001 20.7189 20.8963V15.6544C20.7189 15.0496 20.813 14.4851 20.9877 13.9743C21.5791 12.3076 23.0845 11.2861 25.0872 11.2861H33.8237C36.4447 11.2861 38.192 13.0334 38.192 15.6544ZM18.5684 38.1679H28.2458ZM23.4071 33.3291V38.1679Z"
                              fill="#4C3CA6"
                            />
                            <path
                              d="M18.5684 38.1679H28.2458M23.4071 33.3291V38.1679M38.192 15.6544V20.8963C38.192 22.899 37.1705 24.4044 35.5038 24.9958C34.9931 25.1705 34.4286 25.2646 33.8237 25.2646H30.3291L26.4447 27.8587C25.8667 28.2351 25.0872 27.8184 25.0872 27.1329V25.2646C23.7834 25.2646 22.6813 24.8345 21.9151 24.0684C21.149 23.3023 20.7189 22.2001 20.7189 20.8963V15.6544C20.7189 15.0496 20.813 14.4851 20.9877 13.9743C21.5791 12.3076 23.0845 11.2861 25.0872 11.2861H33.8237C36.4447 11.2861 38.192 13.0334 38.192 15.6544Z"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M33.4761 18.3521H33.4895ZM29.714 18.3521H29.7261ZM25.9492 18.3521H25.9627Z"
                              fill="#4C3CA6"
                            />
                            <path
                              d="M33.4761 18.3521H33.4895M29.714 18.3521H29.7261M25.9492 18.3521H25.9627"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="white" />
                            <circle
                              cx="25"
                              cy="25"
                              r="24.5"
                              stroke="#808080"
                              strokeOpacity="0.3"
                            />
                            <path
                              d="M35.4963 25.0039V27.2889C35.4963 31.5227 33.0769 33.3373 29.4479 33.3373H17.3511C13.7221 33.3373 11.3027 31.5227 11.3027 27.2889V20.0308C11.3027 15.7969 13.7221 13.9824 17.3511 13.9824H20.9802C20.8054 14.4932 20.7113 15.0577 20.7113 15.6625V20.9045C20.7113 22.2082 21.1414 23.3104 21.9076 24.0765C22.6737 24.8426 23.7759 25.2727 25.0796 25.2727V27.141C25.0796 27.8265 25.8592 28.2432 26.4371 27.8668L30.3215 25.2727H33.8162C34.421 25.2727 34.9855 25.1787 35.4963 25.0039V25.0039Z"
                              fill="white"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M38.191 15.6544V20.8963C38.191 22.899 37.1695 24.4044 35.5029 24.9958C34.9921 25.1705 34.4276 25.2646 33.8228 25.2646H30.3281L26.4437 27.8587C25.8658 28.2351 25.0862 27.8184 25.0862 27.1329V25.2646C23.7824 25.2646 22.6803 24.8345 21.9142 24.0684C21.148 23.3023 20.7179 22.2001 20.7179 20.8963V15.6544C20.7179 15.0496 20.812 14.4851 20.9867 13.9743C21.5781 12.3076 23.0835 11.2861 25.0862 11.2861H33.8228C36.4437 11.2861 38.191 13.0334 38.191 15.6544ZM18.5674 38.1679H28.2448ZM23.4061 33.3291V38.1679Z"
                              fill="white"
                            />
                            <path
                              d="M18.5674 38.1679H28.2448M23.4061 33.3291V38.1679M38.191 15.6544V20.8963C38.191 22.899 37.1695 24.4044 35.5029 24.9958C34.9921 25.1705 34.4276 25.2646 33.8228 25.2646H30.3281L26.4437 27.8587C25.8658 28.2351 25.0862 27.8184 25.0862 27.1329V25.2646C23.7824 25.2646 22.6803 24.8345 21.9142 24.0684C21.148 23.3023 20.7179 22.2001 20.7179 20.8963V15.6544C20.7179 15.0496 20.812 14.4851 20.9867 13.9743C21.5781 12.3076 23.0835 11.2861 25.0862 11.2861H33.8228C36.4437 11.2861 38.191 13.0334 38.191 15.6544Z"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M33.4761 18.3521H33.4895ZM29.714 18.3521H29.7261ZM25.9492 18.3521H25.9627Z"
                              fill="white"
                            />
                            <path
                              d="M33.4761 18.3521H33.4895M29.714 18.3521H29.7261M25.9492 18.3521H25.9627"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>

                      <div
                        className={`${
                          Type === "email"
                            ? "single-active-icon"
                            : "single-icon"
                        }`}
                        onClick={() => {
                          setType("email");
                        }}
                      >
                        {Type === "email" ? (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="#4C3CA6" />
                            <path
                              d="M31.8565 36.2093H18.1468C14.0339 36.2093 11.292 34.1528 11.292 29.3544V19.7577C11.292 14.9593 14.0339 12.9028 18.1468 12.9028H31.8565C35.9694 12.9028 38.7113 14.9593 38.7113 19.7577V29.3544C38.7113 34.1528 35.9694 36.2093 31.8565 36.2093Z"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M31.8562 20.4438L27.565 23.8713C26.1529 24.9955 23.836 24.9955 22.4239 23.8713L18.1465 20.4438"
                              stroke="white"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="25"
                              cy="25"
                              r="25"
                              fill="white"
                              fillOpacity="0.3"
                            />
                            <circle
                              cx="25"
                              cy="25"
                              r="24.5"
                              stroke="#505050"
                              strokeOpacity="0.3"
                            />
                            <path
                              d="M31.8565 36.2093H18.1468C14.0339 36.2093 11.292 34.1528 11.292 29.3544V19.7577C11.292 14.9593 14.0339 12.9028 18.1468 12.9028H31.8565C35.9694 12.9028 38.7113 14.9593 38.7113 19.7577V29.3544C38.7113 34.1528 35.9694 36.2093 31.8565 36.2093Z"
                              stroke="#808080"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M31.8562 20.4438L27.565 23.8713C26.1529 24.9955 23.836 24.9955 22.4239 23.8713L18.1465 20.4438"
                              stroke="#808080"
                              strokeWidth="1.2"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>

                      <div
                        className={`${
                          Type === "task" ? "single-active-icon" : "single-icon"
                        }`}
                        onClick={() => {
                          setType("task");
                        }}
                      >
                        {Type === "task" ? (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="25" cy="25" r="25" fill="#4C3CA6" />
                            <path
                              d="M19.623 25.0002H29.0316M19.623 30.3765H25.5101M22.3112 16.6669H27.6876C30.3757 16.6669 30.3757 15.3228 30.3757 13.9787C30.3757 11.2905 29.0316 11.2905 27.6876 11.2905H22.3112C20.9671 11.2905 19.623 11.2905 19.623 13.9787C19.623 16.6669 20.9671 16.6669 22.3112 16.6669Z"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M30.3764 14.0044C34.8522 14.2463 37.0969 15.8996 37.0969 22.042V30.1065C37.0969 35.4829 35.7528 38.1711 29.0324 38.1711H20.9678C14.2474 38.1711 12.9033 35.4829 12.9033 30.1065V22.042C12.9033 15.913 15.1479 14.2463 19.6238 14.0044"
                              stroke="white"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="25"
                              cy="25"
                              r="24.5"
                              fill="white"
                              stroke="#C5C5C5"
                            />
                            <path
                              d="M19.623 25.0002H29.0316M19.623 30.3765H25.5101M22.3112 16.6669H27.6876C30.3757 16.6669 30.3757 15.3228 30.3757 13.9787C30.3757 11.2905 29.0316 11.2905 27.6876 11.2905H22.3112C20.9671 11.2905 19.623 11.2905 19.623 13.9787C19.623 16.6669 20.9671 16.6669 22.3112 16.6669Z"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M30.3764 14.0044C34.8522 14.2463 37.0969 15.8996 37.0969 22.042V30.1065C37.0969 35.4829 35.7528 38.1711 29.0324 38.1711H20.9678C14.2474 38.1711 12.9033 35.4829 12.9033 30.1065V22.042C12.9033 15.913 15.1479 14.2463 19.6238 14.0044"
                              stroke="#808080"
                              strokeWidth="1.3"
                              strokeMiterlimit="10"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-row add-appointment-title-container">
                  <div className="form-group col-12 title-form-group">
                    <TextField
                      size="small"
                      className="input-style"
                      label="Title "
                      value={Title}
                      // value={
                      //   SingleAppointmentData
                      //     ? SingleAppointmentData?.title
                      //     : Title
                      // }
                      onChange={(e) => {
                        setIsCustomTitle(true);
                        setTitle(e.target.value);
                      }}
                    />
                    {TitleError && (
                      <p className="errorMessage title-error">
                        Title is required
                      </p>
                    )}
                  </div>
                </div>

                <div className="form-row add-appointment-start-end-time-container">
                  <div className="form-group col-6">
                    <label>Date</label>
                    <div className="start-date">
                      <span>
                        {LocalStartDate.toLocaleString().slice(0, 10)}
                      </span>
                      <img
                        onClick={() => {
                          setStartWeekViewToggler(!StartWeekViewToggler);
                        }}
                        src={CalenderSVG}
                        alt="calendar"
                        width={25}
                        height={25}
                      />
                    </div>
                    {StartWeekViewToggler && (
                      <Calendar
                        className="start-date-calendar"
                        onChange={(value, event) => {
                          setStartWeekViewToggler(false);
                          setLocalStartDate(value);
                        }}
                        // defaultValue
                        value={LocalStartDate}
                      />
                    )}
                    {LocalStartDateError && (
                      <p className="errorMessage">Date is required</p>
                    )}
                  </div>

                  <div className="form-group col-3 start-time-drop-down">
                    <label>Start Time</label>

                    <select
                      style={{ textTransform: "upperCase" }}
                      className="start-time"
                      onChange={(e) => {
                        setStartTime(e.target.value);
                      }}
                      defaultValue={StartTime}
                    >
                      {/* {StartTimeArray.map((item, index) => {
                      return EndTime > item ? (
                        <option
                          style={{ textTransform: "upperCase" }}
                          value={item}
                        >
                          {item}
                        </option>
                      ) : (
                        ""
                      );
                    })} */}

                      {StartTimeArray.map((item, index) => {
                        return (
                          <option
                            key={index}
                            style={{ textTransform: "upperCase" }}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })}
                    </select>
                    {StartTimeError && (
                      <p className="errorMessage start-time-error">
                        Start time is required
                      </p>
                    )}
                  </div>

                  <div className="form-group col-3 end-time-drop-down">
                    <label>End Time</label>
                    <select
                      style={{ textTransform: "upperCase" }}
                      className="end-time"
                      onChange={(e) => {
                        setEndTime(e.target.value);
                      }}
                      defaultValue={EndTime}
                    >
                      {/* {EndTimeArray.map((item, index) => {
                      return StartTime < item ? (
                        <option
                          style={{ textTransform: "upperCase" }}
                          value={item}
                        >
                          {item}
                        </option>
                      ) : (
                        ""
                      );
                    })} */}
                      {EndTimeArray.map((item, index) => {
                        return (
                          <option
                            key={index}
                            style={{ textTransform: "upperCase" }}
                            value={item}
                          >
                            {item}
                          </option>
                        );
                      })}
                    </select>
                    {EndTimeError && (
                      <p className="errorMessage end-time-error">
                        End time is required
                      </p>
                    )}
                  </div>
                </div>

                {AppointmentId !== "" ? (
                  <div className="form-row add-appointment-clients-container">
                    <div className="form-group col-12 client-form-group">
                      <Autocomplete
                        id="tags-outlined"
                        options={Clients}
                        getOptionLabel={(option) => option.name}
                        defaultValue={ClientDetails && ClientDetails}
                        onChange={(event, value, reason, details) => {
                          setClientID(value.id);
                          setClientName(value.name);
                          setClientObject(value);
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} id={option.id}>
                            {
                              <Card
                                sx={{ display: "flex" }}
                                elevation={0}
                                className="add-appointment-client-dropdown"
                              >
                                <Avatar
                                  className="add-appointment-client-dropdown-avatar"
                                  {...stringAvatar(option.name)}
                                />
                                <Typography
                                  component="div"
                                  variant="p"
                                  className="add-appointment-client-dropdown-name"
                                >
                                  {option.name}
                                </Typography>
                              </Card>
                            }
                          </MenuItem>
                        )}
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              size="small"
                              label="Clients"
                            />
                          );
                        }}
                      />
                      {ClientError && (
                        <p className="errorMessage client-error">
                          Client is required
                        </p>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="form-row add-appointment-clients-container">
                    <div className="form-group col-12 client-form-group">
                      <Autocomplete
                        id="tags-outlined"
                        options={Clients}
                        getOptionLabel={(option) => option.name}
                        // defaultValue={ClientDetails && ClientDetails}
                        onChange={(event, value, reason, details) => {
                          setClientID(value.id);
                          setClientName(value.name);
                          setClientObject(value);
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} id={option.id}>
                            {
                              <Card
                                sx={{ display: "flex" }}
                                elevation={0}
                                className="add-appointment-client-dropdown"
                              >
                                <Avatar
                                  className="add-appointment-client-dropdown-avatar"
                                  {...stringAvatar(option.name)}
                                />
                                <Typography
                                  component="div"
                                  variant="p"
                                  className="add-appointment-client-dropdown-name"
                                >
                                  {option.name}
                                </Typography>
                              </Card>
                            }
                          </MenuItem>
                        )}
                        renderInput={(params) => {
                          return (
                            <TextField
                              {...params}
                              size="small"
                              label="Clients"
                            />
                          );
                        }}
                      />
                      {ClientError && (
                        <p className="errorMessage client-error">
                          Client is required
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {Deals?.length !== 0 && AppointmentId !== "" ? (
                  <div className="form-row add-appointment-deals-container">
                    <div className="form-group col-12 deal-form-group">
                      <Autocomplete
                        id="tags-outlined"
                        options={Deals}
                        getOptionLabel={(option) =>
                          option.property?.propertyTitle
                        }
                        defaultValue={DealDetails && DealDetails}
                        onChange={(event, value, reason, details) => {
                          setDealID(value.id);
                          setDealObject(value);
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} id={option.id}>
                            {
                              <Card
                                elevation={0}
                                className="add-appointment-deals-dropdown"
                              >
                                <div className="add-appointment-deals-dropdown-left">
                                  {option.property.images?.length !== 0 ? (
                                    <img
                                      className="add-appointment-deals-dropdown-image"
                                      src={option.property.images[0]}
                                      alt="property"
                                    />
                                  ) : (
                                    <svg
                                      width="61"
                                      height="56"
                                      viewBox="0 0 61 56"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g filter="url(#filter0_d_1148_3130)">
                                        <rect
                                          x="4"
                                          y="3"
                                          width="52.3636"
                                          height="48"
                                          rx="5"
                                          fill="#4C3CA6"
                                        />
                                      </g>
                                      <path
                                        d="M16 38V24.6842L25.0625 18.6316L34.125 24.6842V38H28.0833V29.5263H22.0417V38H16ZM45 15V38H36.5417V23.3889L35.3333 22.59V19.8421H32.9167V20.9679L28.0833 17.7479V15H45ZM41.375 29.5263H38.9583V31.9474H41.375V29.5263ZM41.375 24.6842H38.9583V27.1053H41.375V24.6842ZM41.375 19.8421H38.9583V22.2632H41.375V19.8421Z"
                                        fill="white"
                                      />
                                      <defs>
                                        <filter
                                          id="filter0_d_1148_3130"
                                          x="0"
                                          y="0"
                                          width="60.3633"
                                          height="56"
                                          filterUnits="userSpaceOnUse"
                                          color-interpolation-filters="sRGB"
                                        >
                                          <feFlood
                                            flood-opacity="0"
                                            result="BackgroundImageFix"
                                          />
                                          <feColorMatrix
                                            in="SourceAlpha"
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                            result="hardAlpha"
                                          />
                                          <feOffset dy="1" />
                                          <feGaussianBlur stdDeviation="2" />
                                          <feComposite
                                            in2="hardAlpha"
                                            operator="out"
                                          />
                                          <feColorMatrix
                                            type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                          />
                                          <feBlend
                                            mode="normal"
                                            in2="BackgroundImageFix"
                                            result="effect1_dropShadow_1148_3130"
                                          />
                                          <feBlend
                                            mode="normal"
                                            in="SourceGraphic"
                                            in2="effect1_dropShadow_1148_3130"
                                            result="shape"
                                          />
                                        </filter>
                                      </defs>
                                    </svg>
                                  )}
                                </div>

                                <div className="add-appointment-deals-dropdown-right">
                                  <p className="property-title">
                                    {option.property.propertyTitle}
                                  </p>
                                  <p className="property-address">
                                    {option.property.address}
                                  </p>
                                  <p className="deal-price">
                                    {option.dealPrice}
                                  </p>
                                </div>
                              </Card>
                            }
                          </MenuItem>
                        )}
                        renderInput={(params) => {
                          return (
                            <TextField {...params} size="small" label="Deals" />
                          );
                        }}
                      />
                      {DealsError && (
                        <p className="errorMessage deal-error">
                          Deal is required
                        </p>
                      )}
                    </div>
                  </div>
                ) : (
                  Deals?.length !== 0 &&
                  AppointmentId === "" && (
                    <div className="form-row add-appointment-deals-container">
                      <div className="form-group col-12 deal-form-group">
                        <Autocomplete
                          id="tags-outlined"
                          options={Deals}
                          getOptionLabel={(option) =>
                            option.property?.propertyTitle
                          }
                          onChange={(event, value, reason, details) => {
                            setDealID(value.id);
                            setDealObject(value);
                          }}
                          renderOption={(props, option) => (
                            <MenuItem {...props} id={option.id}>
                              {
                                <Card
                                  elevation={0}
                                  className="add-appointment-deals-dropdown"
                                >
                                  <div className="add-appointment-deals-dropdown-left">
                                    {option.property.images?.length !== 0 ? (
                                      <img
                                        className="add-appointment-deals-dropdown-image"
                                        src={option.property.images[0]}
                                        alt="property"
                                      />
                                    ) : (
                                      <svg
                                        width="61"
                                        height="56"
                                        viewBox="0 0 61 56"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g filter="url(#filter0_d_1148_3130)">
                                          <rect
                                            x="4"
                                            y="3"
                                            width="52.3636"
                                            height="48"
                                            rx="5"
                                            fill="#4C3CA6"
                                          />
                                        </g>
                                        <path
                                          d="M16 38V24.6842L25.0625 18.6316L34.125 24.6842V38H28.0833V29.5263H22.0417V38H16ZM45 15V38H36.5417V23.3889L35.3333 22.59V19.8421H32.9167V20.9679L28.0833 17.7479V15H45ZM41.375 29.5263H38.9583V31.9474H41.375V29.5263ZM41.375 24.6842H38.9583V27.1053H41.375V24.6842ZM41.375 19.8421H38.9583V22.2632H41.375V19.8421Z"
                                          fill="white"
                                        />
                                        <defs>
                                          <filter
                                            id="filter0_d_1148_3130"
                                            x="0"
                                            y="0"
                                            width="60.3633"
                                            height="56"
                                            filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB"
                                          >
                                            <feFlood
                                              flood-opacity="0"
                                              result="BackgroundImageFix"
                                            />
                                            <feColorMatrix
                                              in="SourceAlpha"
                                              type="matrix"
                                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                              result="hardAlpha"
                                            />
                                            <feOffset dy="1" />
                                            <feGaussianBlur stdDeviation="2" />
                                            <feComposite
                                              in2="hardAlpha"
                                              operator="out"
                                            />
                                            <feColorMatrix
                                              type="matrix"
                                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                            />
                                            <feBlend
                                              mode="normal"
                                              in2="BackgroundImageFix"
                                              result="effect1_dropShadow_1148_3130"
                                            />
                                            <feBlend
                                              mode="normal"
                                              in="SourceGraphic"
                                              in2="effect1_dropShadow_1148_3130"
                                              result="shape"
                                            />
                                          </filter>
                                        </defs>
                                      </svg>
                                    )}
                                  </div>

                                  <div className="add-appointment-deals-dropdown-right">
                                    <p className="property-title">
                                      {option.property.propertyTitle}
                                    </p>
                                    <p className="property-address">
                                      {option.property.address}
                                    </p>
                                    <p className="deal-price">
                                      {option.dealPrice}
                                    </p>
                                  </div>
                                </Card>
                              }
                            </MenuItem>
                          )}
                          renderInput={(params) => {
                            return (
                              <TextField
                                {...params}
                                size="small"
                                label="Deals"
                              />
                            );
                          }}
                        />
                        {DealsError && (
                          <p className="errorMessage deal-error">
                            Deal is required
                          </p>
                        )}
                      </div>
                    </div>
                  )
                )}

                <div className="form-row add-appointment-comments-container">
                  <div className="form-group col-12 comments-form-group">
                    <textarea
                      rows="7"
                      placeholder="Comments"
                      className="comments-area"
                      onChange={(e) => {
                        setComments(e.target.value);
                      }}
                      defaultValue={Comments}
                    />
                  </div>
                </div>

                {AppointmentId !== "" ? (
                  <div className="form-row add-appointment-users-container">
                    <div className="form-group col-12 user-form-group">
                      <Autocomplete
                        id="tags-outlined"
                        options={Agents}
                        getOptionLabel={(option) => option.name}
                        defaultValue={AgentDetails && AgentDetails}
                        onChange={(event, value, reason, details) => {
                          setAgentID(value.id);
                          setUserObject(value);
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} id={option.id}>
                            {
                              <Card
                                sx={{ display: "flex" }}
                                elevation={0}
                                className="add-appointment-user-dropdown"
                              >
                                <Avatar
                                  className="add-appointment-user-dropdown-avatar"
                                  {...stringAvatar(option.name)}
                                />
                                <Typography
                                  component="div"
                                  variant="p"
                                  className="add-appointment-user-dropdown-name"
                                >
                                  {option.name}
                                </Typography>
                              </Card>
                            }
                          </MenuItem>
                        )}
                        renderInput={(params) => {
                          return (
                            <TextField {...params} size="small" label="Users" />
                          );
                        }}
                      />
                      {UserError && (
                        <p className="errorMessage user-error">
                          User is required
                        </p>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="form-row add-appointment-users-container">
                    <div className="form-group col-12 user-form-group">
                      <Autocomplete
                        id="tags-outlined"
                        options={Agents}
                        getOptionLabel={(option) => option.name}
                        defaultValue={Agents[0]}
                        onChange={(event, value, reason, details) => {
                          setAgentID(value.id);
                          setUserObject(value);
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} id={option.id}>
                            {
                              <Card
                                sx={{ display: "flex" }}
                                elevation={0}
                                className="add-appointment-user-dropdown"
                              >
                                <Avatar
                                  className="add-appointment-user-dropdown-avatar"
                                  {...stringAvatar(option.name)}
                                />
                                <Typography
                                  component="div"
                                  variant="p"
                                  className="add-appointment-user-dropdown-name"
                                >
                                  {option.name}
                                </Typography>
                              </Card>
                            }
                          </MenuItem>
                        )}
                        renderInput={(params) => {
                          return (
                            <TextField {...params} size="small" label="Users" />
                          );
                        }}
                      />
                      {UserError && (
                        <p className="errorMessage user-error">
                          User is required
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {IsCompleted === true ? (
                  <div className="completed-appointment-modal-footer">
                    <p>This appointment is completed</p>
                  </div>
                ) : (
                  <div className="add-appointment-modal-footer">
                    {AppointmentId !== "" && (
                      <button
                        type="button"
                        onClick={HandleMarkAsDone}
                        className="add-appointment-mark-as-done-button"
                      >
                        Mark As Done
                      </button>
                    )}
                    <button
                      type="submit"
                      className="add-appointment-button"
                      disabled={IsBtnDisable}
                    >
                      {IsBtnDisable && (
                        <span className="spinner-border spinner-border-sm mr-1"></span>
                      )}
                      {AppointmentId !== "" ? "Update" : "Save"}
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        )}
      </Modal>
    </Fragment>
  );
};

export default AddUpdateAppointmentModal;
